"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./HomepageBannerRebrand.scss");

var _aos = _interopRequireDefault(require("aos"));

require("aos/dist/aos.css");

var _HomepageBannerItems = _interopRequireDefault(require("../HomepageBannerItems"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var HomepageBannerRebrand = function HomepageBannerRebrand() {
  (0, _react.useEffect)(function () {
    _aos.default.init({
      duration: 1000
    });
  }, []);
  return _react.default.createElement("div", {
    className: "blue-section"
  }, _react.default.createElement("div", {
    className: "flex-cont"
  }, _react.default.createElement(_HomepageBannerItems.default, {
    image: "https://motorkiki-rebrand-static-assets.s3.eu-west-2.amazonaws.com/images/icons/16976-assets_icon-tyre-red.svg",
    firstText: "Get the tyres",
    yellowText: "you",
    secondText: "need"
  }), _react.default.createElement(_HomepageBannerItems.default, {
    image: "https://motorkiki-rebrand-static-assets.s3.eu-west-2.amazonaws.com/images/icons/16976-assets_icon-map-red.svg",
    firstText: "Fitted Where",
    yellowText: "you",
    secondText: "want"
  }), _react.default.createElement(_HomepageBannerItems.default, {
    image: "https://motorkiki-rebrand-static-assets.s3.eu-west-2.amazonaws.com/images/icons/16976-assets_icon-pig-red.svg",
    firstText: "For the price",
    yellowText: "you",
    secondText: "love"
  })));
};

var _default = HomepageBannerRebrand;
exports.default = _default;